"use strict";

exports.__esModule = true;
exports.tabPropTypes = exports.tabsPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var tabsPropTypes = {
  align: (0, _propTypes.oneOf)(Object.keys(_constants.ALIGN)),
  'aria-labelledby': _propTypes.string,
  children: _propTypes.node,
  defaultSelectedTabIndex: _propTypes.number,
  id: _propTypes.string,
  label: _propTypes.string.isRequired,
  height: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  maxTabWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  onChange: _propTypes.func,
  position: (0, _propTypes.oneOf)(Object.keys(_constants.POSITION)),
  selectedTabIndex: _propTypes.number,
  theme: _propTypes.object
};
exports.tabsPropTypes = tabsPropTypes;
var tabPropTypes = {
  children: _propTypes.node,
  disabled: _propTypes.bool,
  icon: _propTypes.element,
  id: _propTypes.string,
  index: _propTypes.number,
  maxWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  panelId: _propTypes.string,
  selected: _propTypes.bool,
  title: _propTypes.node.isRequired
};
exports.tabPropTypes = tabPropTypes;